import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import DomesticShippingServicesPage from '@/v2/components/pages/public-pages/domestic-shipping-services-page'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/public-pages/domestic-shipping-services-page'

interface DomesticShippingServicesPageProps {}

const Page: React.FC<DomesticShippingServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.domestic_shipping_services.title ?? ''}
        keywords={META_CONTENTS.domestic_shipping_services?.keywords ?? ''}
        description={META_CONTENTS.domestic_shipping_services?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <DomesticShippingServicesPage />
    </>
  )
}

export default Page
